<template>
  <div class="w-full">index</div>
</template>
